// actions/aboutUs.actions.js
import callApi from "../../utils/callApi";
import { setDataSection, setLoading, setError } from "../reducers/aboutUs.reducer";

export const getDataSection = (path, sectionName) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true)); // Bắt đầu loading
      const res = await callApi(path, "GET", null);

      // Cập nhật dữ liệu section
      dispatch(setDataSection({ section: sectionName, ...res.data.data }));
      dispatch(setLoading(false)); // Kết thúc loading
    } catch (err) {
      dispatch(setError(err.message));
      dispatch(setLoading(false));
    }
  };
};
